import React from "react";
import SearchHubCard from "../global/SearchHubCard";

export default function HomeSearch({ onSearch }) {
  return (
    <section className="p2-home-search">
      <SearchHubCard onPress={onSearch} />
    </section>
  );
}
